import { Component, Input } from '@angular/core';
import { SetService, JwtService, PageService, HttpService } from 'ngx-block-core';
import { BlockBaseComponent } from "../../../components/block";
import { ActivatedRoute } from '@angular/router';
import { NzModalService, NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import { eventType2, selectSize, selectThemeSize, iconTheme } from "../../../data/data";
@Component({
    selector: 'app-sucu05-button0010002',
    templateUrl: './sucu05-button0010002.component.html',
    styles: [
        ``
    ]
})
export class Sucu05Button0010002Component extends BlockBaseComponent {

    @Input() sets = {
        blockCode: "sucublock13",
        blockId: "",
        blockName: "链接按钮",
        layoutId: "",
        blockType: 'button',
        blockChildType: '',
        versionCode: 4,
        attributes: [],
        sets: {
            acl: false
        },
        events: [
        ],

        styles: {
            nzMode: 'button',//button,text
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzText: '按钮名称',
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },
            nzOpen: true,
            nzConfirm: {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定吗？"
            },
            nzPopover: {
                nzUsed: false,
                nzContent: [],
                nzTrigger: 'hover',
                nzButton: false,
                nzButtonType: 'jump',
                nzButtonText: '高级搜索'
            },
            nzShape: null
        },
        datas: {
            nzLinkAdd: 'PrintLabel:',
            nzJoin: false,
            nzJumpType: 'location',//open
            nzPopJump: false,
            nzParamType: ':???',//':???','?&&&'
            nzServiceParam: [],
            nzServiceParamDetail: { "sequ": 1 },
        }
    };

    autoUpdate() {
        if (this.sets.versionCode < 2) {

            this.sets.datas['nzJoin'] = false;
            this.sets.datas['nzJumpType'] = 'location';
            this.sets.versionCode = 2;
        }
        if (this.sets.versionCode < 3) {

            this.sets.styles['nzPopover'] = {
                nzUsed: false,
                nzContent: [],
                nzTrigger: 'click',
                nzButton: false,
                nzButtonType: 'jump',
                nzButtonText: '点击'
            }
            this.sets.datas['nzPopJump'] = false;
            this.sets.versionCode = 3;
        }
        if (this.sets.versionCode < 4) {
            if (this.sets.datas['nzPopJump'] === undefined)
                this.sets.datas['nzPopJump'] = false;
            this.sets.versionCode = 4;
        }
        // console.log('this.sets.datas', this.sets.datas, this.sets.styles)
    }

    doValueChange(val: any) {
        // throw new Error("Method not implemented.");
    }
    pzSwitchFn(data: any) {
        // throw new Error("Method not implemented.");
    }
    switchFn(data: any) {
        // throw new Error("Method not implemented.");
    }
    onClick(click = true) {
        if (this.sets.datas.nzPopJump == false || click === false) {
            let linkaddress = this.sets.datas.nzLinkAdd;
            let paramsurl = '';
            let hastable = false;
            let tableData;
            let serviceParamDetail = this.sets.datas.nzServiceParamDetail;
            for (const key in serviceParamDetail) {
                if (serviceParamDetail.hasOwnProperty(key)) {
                    const element = serviceParamDetail[key];
                    if (element.type == "1") {
                        hastable = true;
                        tableData = this.pageService.pageBlockDatas[element.source]['checkValue'];
                    } else {
                    }
                }
            }
            // todo 暂时写死限制一条，后期可配置
            if (hastable) {
                if (typeof tableData != 'undefined') {
                    if (tableData.length != 1) {
                        this.modalService.info({
                            nzTitle: "提示",
                            nzContent: "请只勾选一条记录"
                        });
                        return;
                    }
                } else {
                    this.modalService.info({
                        nzTitle: "提示",
                        nzContent: "请勾选一条记录"
                    });
                    return;
                }
            }

            for (let index = 0; index < this.sets.datas.nzServiceParam.length; index++) {
                const param = this.sets.datas.nzServiceParam[index];
                switch (this.sets.datas.nzParamType) {
                    case ':???':
                        const value = this.pageService.getServiceParam(this.sets.datas['nzServiceParamDetail'][param], this.activatedRoute);
                        if (index === 0) {
                            paramsurl = value;
                        } else {
                            paramsurl = paramsurl + '?' + value;
                        }
                        break;
                    case '?&&&':

                        break;
                    default:
                        break;
                }
            }
            if (paramsurl !== '') {
                linkaddress = linkaddress + paramsurl;
            }
            if (this.sets.datas.nzJoin) {
                linkaddress = this.jwtService.getUserResourceUrl() + linkaddress
            }
            console.log('linkaddress', this.sets.datas.nzJumpType, linkaddress)

            if (this.sets.datas.nzJumpType === 'location') {
                window.location.href = linkaddress;
            } else {
                window.open(linkaddress);
            }
            // window.open(linkaddress);
        } else {
            console.log("click", click, this.sets.datas.nzPopJump)
        }


    }

    popClick() {
        this.onClick(false);
    }
    constructor(
        private activatedRoute: ActivatedRoute,
        public setService: SetService,
        protected pageService: PageService,
        protected jwtService: JwtService,
        private modalService: NzModalService,
        protected http: HttpService,
    ) {
        super(setService, pageService, jwtService, http);
    }
    setDataInit() {
        this.setData = [
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'input',
                                inputs: {
                                    nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                                }
                            },
                            {

                                name: 'select',
                                inputs: {
                                    nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                                outputs: {
                                    ngModelChange: (event) => {


                                        if (event == 'twotone') {

                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = true;

                                        } else {
                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = false;

                                        }


                                        this.setService.onReLoadbBlock(this.layoutid);

                                    }
                                }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                            },
                            {
                                name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                                inputs: {
                                    nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                                }
                            },

                            {
                                name: 'color',
                                inputs: {
                                    nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "形状 : ", nzKeys: ['styles', 'nzShape'], nzData: [{ value: null, label: '无' }, { value: 'circle', label: 'circle' }, { value: 'round', label: 'round' }] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
                            },
                            { name: 'nzConfirm' },
                            {
                                name: 'nzPopover',
                                inputs: { nzPop: false }

                            },
                        ]
                    },
                ]
            },
            {
                tabName: '功能',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            {
                                name: 'input',
                                inputs: {
                                    nzText: "跳转地址 : ", nzKeys: ['datas', 'nzLinkAdd']
                                }
                            },
                            {
                                name: 'select',
                                inputs: {
                                    nzText: "跳转方式 : ", nzKeys: ['datas', 'nzJumpType'],
                                    nzData: [{ value: 'location', label: '本页' }, { value: 'open', label: '打开新页面' }]
                                }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "弹出跳转 : ", nzKeys: ['datas', 'nzPopJump'], nzPopContent: ['在弹出提示中点击按钮跳转'] }
                            },

                            {
                                name: 'select',
                                inputs: {
                                    nzText: "参数组装方式 : ", nzKeys: ['datas', 'nzParamType'],
                                    nzData: [{ value: ':???', label: ':???' }, { value: 'open', label: '?&&&' }], nzPopContent: [':???:打开注册表程序', '?&&&:常用链接传参']
                                }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "自动拼接 : ", nzKeys: ['datas', 'nzJoin'], nzPopContent: ['自动拼接服务器地址'] }
                            },

                            {
                                name: 'nzServiceParam',
                                inputs: { nzNeedUrlName: true, nzServiceParam: this.sets.datas.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzServiceParamDetail }
                            },
                        ]
                    }
                ]
            },
        ]
    }



}
